import { Box, Button, Chip, Typography } from '@mui/material';
import { CitationListItem as CitationListItemStyle } from '../styles';
import { BrightLocal, Campaign, CampaignStatus } from '../types';

interface CitationListItemProps {
  title: string;
  status: CampaignStatus;
  date: string;
  onViewDetails?: () => void;
}

export const CitationListItem = ({
  title,
  status,
  date,
  onViewDetails
}: CitationListItemProps) => {
  const statusText = status.split('_').join(' ');

  return (
    <Box sx={CitationListItemStyle.itemContainer}>
      <Box sx={CitationListItemStyle.leftSection}>
        <Typography sx={CitationListItemStyle.title}>{title}</Typography>
        <Chip label={statusText} sx={{...CitationListItemStyle.chip(status), textTransform: 'capitalize'}} />
      </Box>
      <Box sx={CitationListItemStyle.rightSection}>
        <Typography sx={CitationListItemStyle.date}>{date}</Typography>
        <Button
          variant="outlined"
          color="primary"
          onClick={onViewDetails}
          sx={CitationListItemStyle.viewDetailsButton}
        >
          View Details
        </Button>
      </Box>
    </Box>
  );
};

